import logger from './utils/logger.js';
import { formatProductName } from './utils/product.js';
import { g as getItemVariantsWithoutSize } from './helpers-qU2Vf3ni.js';
import { getCookie } from './utils/cookies.js';
import { r as COOKIE_ACCOR_GTM_CART_TRACKING } from './cookies-l-jEMp6P.js';
import './currency-_kacFJHO.js';
import './language-BHHwgtQp.js';
import './payment-a4IKjS7g.js';

// Function: Pushes "begin_checkout", "add_shipping_info" or "add_payment_info" event to dataLayer
const dataLayerCheckoutAccor = ({ cart, affiliation, brand, eventName, siteFilters, }) => {
    var _a;
    window.dataLayer = window.dataLayer || [];
    const ga4PurchaseEventItems = [];
    const cartGtmDataCookie = (_a = getCookie(COOKIE_ACCOR_GTM_CART_TRACKING)) === null || _a === void 0 ? void 0 : _a.toString();
    const cartGtmData = cartGtmDataCookie ? JSON.parse(cartGtmDataCookie) : {};
    cart.items.forEach((item, i) => {
        var _a, _b, _c, _d, _e;
        const categoryName = ((_a = [...item.product.name_en.categories].reverse()[0]) === null || _a === void 0 ? void 0 : _a.name_en) || '';
        const { extractedVariants, removedSizeVariant } = getItemVariantsWithoutSize(item.configured_variant, siteFilters);
        const discount = (_d = (_c = (_b = item.configured_variant) === null || _b === void 0 ? void 0 : _b.price_gap) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : item.product.price_gap.value;
        const itemListName = cartGtmData[item.product.sku];
        ga4PurchaseEventItems.push({
            // TODO: GA4 - For Kit and Configurable products, we need to add the parent product SKU to the item_id field
            affiliation,
            discount,
            index: i,
            item_brand: brand,
            item_category: categoryName,
            ...(removedSizeVariant && {
                item_category2: removedSizeVariant,
            }),
            item_id: item.product.sku,
            item_list_id: categoryName,
            ...(itemListName && {
                item_list_name: itemListName,
            }),
            item_name: formatProductName({
                name: ((_e = item.product.name_en) === null || _e === void 0 ? void 0 : _e.product_name) || item.product.name,
                lang: 'en',
                siteFilters: siteFilters || null,
            }),
            ...(extractedVariants && {
                item_variant: extractedVariants,
            }),
            price: item.prices.price.value,
            quantity: item.quantity,
            subscription: 'no',
        });
    });
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
        event: eventName,
        ecommerce: {
            currency: cart.prices.subtotal_including_tax.currency,
            value: cart.prices.subtotal_including_tax.value,
            items: ga4PurchaseEventItems,
        },
    });
    logger(`${eventName} event sent`, { category: 'analytics' });
};

export { dataLayerCheckoutAccor as d };
//# sourceMappingURL=checkout-17GMuD7V.js.map
